import { useState } from 'react';
import { AritoDialog, AritoForm, AritoHeaderTabs, AritoIcon, BottomActionBarV2 } from '@/components/custom/erp';
import { initialValues, searchSchema, type SearchFormValues } from '../schema';
import { BasicInfo, DetailsTab, OtherTab } from './tabs';
import type { TaiKhoan } from '@/types/schemas';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: SearchFormValues & { ma_tk: string }) => void;
}

const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ open, onClose, onSearch }) => {
  const [account, setAccount] = useState<TaiKhoan | null>(null);

  const handleSubmit = (data: SearchFormValues) => {
    onSearch({
      ...data,
      ma_tk: account?.uuid || ''
    });
  };

  return (
    <AritoDialog
      open={open}
      onClose={onClose}
      title='Sổ quỹ in từng ngày'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoForm
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={handleSubmit}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[800px]'>
            <BasicInfo account={account} setAccount={setAccount} />

            <AritoHeaderTabs
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: <DetailsTab />
                },
                {
                  id: 'other',
                  label: 'Khác',
                  component: <OtherTab />
                }
              ]}
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} />}
      />
    </AritoDialog>
  );
};

export default InitialSearchDialog;
